import { withInstall } from "../../utils"

import scTabs from './component/ScTabs.vue'

export const ScTabs = withInstall(scTabs);